// src/data/projects.js
// Single source of truth for all project metadata.
// Add new projects here. The homepage and the /projects listing page both import from this file.

const projects = [
  {
    slug: 'comet-hunter',
    title: 'Comet Hunter',
    tagline: 'a fault-tolerant pipeline for sungrazing comet discovery.',
    description: 'A Python package for automating the end-to-end sungrazing comet discovery workflow using NASA SOHO LASCO imagery. Features a fault-tolerant ingestion pipeline, state-machine-driven lifecycle tracking, concurrent processing, and scientific image processing for comet detection.',
    tech: ['Python', 'SQLite', 'REST API', 'Image Processing', 'Concurrency'],
    featured: true,
  },
  {
    slug: 'six-degree-bacon',
    title: 'Six Degree Bacon',
    tagline: 'AI assisted coding done right.',
    description: 'The "Six Degrees of Kevin Bacon" game inverted: instead of the shortest path between two things, it finds the longest meaningful one, a chain of real, sourced connections that hops across domains until it lands somewhere genuinely surprising. A local-first, zero-LLM engine traverses a curated, Wikidata-aligned knowledge graph, where every trust and surprise score is deterministic and reproducible by hand.',
    tech: ['Claude Code', 'Python', 'networkx', 'Wikidata', 'Graph Traversal'],
    featured: true,
  },
  {
    slug: 'hierarchical-music-genre-classification',
    title: 'Hierarchical Music Genre Classification',
    tagline: 'naming the exact genre more often by respecting the genre tree.',
    description: 'A local-classifier-per-parent-node hierarchical classifier over FMA Large: 47,547 tracks, 518 features, 20 leaf genres, with six learners benchmarked at every node. Class-imbalance remedies are resampled inside the cross-validation folds rather than before them, so the evaluation stays leakage-free. Selective top-down got the exact genre right for 50.6% of tracks against 49.4% for a flat classifier, ahead in all ten cross-validation folds.',
    tech: ['Python', 'scikit-learn', 'XGBoost', 'imbalanced-learn', 'Cross-validation'],
    featured: true,
  },
  {
    slug: 'ask-me-anything',
    title: 'Ask Me Anything',
    tagline: 'a RAG powered application.',
    description: 'An application powered by Retrieval-Augmented Generation (RAG). It allows users to submit questions specifically about me, and the system responds with generated text based on the most relevant information from the knowledge base. The knowledge base is built from my resume, blogs, projects, writings, and other personal sources.',
    tech: ['Python', 'RAG', 'LangChain', 'Embeddings', 'FastAPI', 'React'],
  },
  {
    slug: 'structured-data-extraction',
    title: 'Structured Data Extraction',
    tagline: 'using a locally hosted large language model.',
    description: 'This project automates the extraction of structured information from unstructured PDF invoices using locally hosted LLM. It removes the need for manual data entry or rigid template-based extraction logic, offering a flexible and accurate solution that can adapt to varied invoice formats.',
    tech: ['Python', 'LLM', 'Ollama', 'PDF Parsing'],
  },
  {
    slug: 'music-genre-recognition',
    title: 'Music Genre Recognition Web App',
    tagline: 'using a carefully designed machine learning model.',
    description: 'A web application which predicts the genre for a song selected by the user. The application allows users to search for a song, and once a particular song is selected, user is presented with the true and predicted genres of the song.',
    tech: ['Python', 'React', 'Express', 'Flask', 'Random Forest'],
    featured: false,
  },
]

export default projects;
